<div>
    <h5>Transaction Date</h5>
    <span>{{
        (model().transactionDate?.toDate() | dateFormat: DateFormat.dateOnly : 'local' | uppercase) ?? 'Unspecified'
    }}</span>
</div>

<div>
    <h5>Merchant</h5>
    <span>{{ (merchantValue$ | async)?.viewValue ?? 'Unspecified' }}</span>
</div>
